// Lightweight singleton toast bus — no external dependencies, no prop drilling.
// Usage: showToast("message") from anywhere; <ToastDisplay /> renders it.

const listeners = new Set();

export function showToast(message, duration = 4000) {
  listeners.forEach(fn => fn(message, duration));
}

export function onToast(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
